import { useEffect, useState, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@lib/supabase/client";
import { useAuth } from "@app/providers/AuthProvider";

const AdminProtectedRoute = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (authLoading) return;

    if (!user) { navigate("/auth"); return; }

    const verify = async () => {
      const { data: adminRole } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user.id)
        .eq("role", "admin")
        .maybeSingle();

      if (!adminRole) { navigate("/"); return; }

      setChecking(false);
    };
    verify();
  }, [navigate, user, authLoading]);

  if (checking) return null;
  return <>{children}</>;
};

export default AdminProtectedRoute;
